import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { FlagListResponse } from '@/types/patient-chart-api';

/**
 * Master flag catalog — categorized list of every available patient
 * flag (curl-verified by Andrew 2026-05-20).
 *
 * Wire:
 *
 *   GET /api/Appointment/GetFlagList
 *       → FlagListResponse[]
 *
 * Note the endpoint is under `/api/Appointment`, NOT `/api/Patients` —
 * Flutter `api_constants.dart` ships it there because the same catalog
 * powers the appointment row-warning strip in scheduling. A duplicate
 * scheduling hook exists at `@/services/scheduling/use-flag-list`; this
 * patients-module hook isolates the queryKey under the chart-namespace
 * so the AddFlagsDialog can refetch independently and so realtime
 * invalidation stays scoped to the chart surface.
 *
 * Cached aggressively (15 min) — static lookup that changes rarely.
 */

export function useFlagMasterList(enabled = true) {
  return useQuery({
    queryKey: ['patient-chart-flag-master-list'],
    queryFn: ({ signal }) =>
      get<FlagListResponse[]>('/api/Appointment/GetFlagList', { signal }),
    enabled,
    staleTime: 15 * 60 * 1000,
  });
}
